<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Reporte de abonos de compras</h3>
            </div>
            <div class="layout__controls">
                <div class="form-inline">
                    <button @click="consultar" class="btn-info btn--bigger"><i class="fa fa-search"></i><span>Consultar</span></button>
                    <button @click="exportar" class="btn-success btn--bigger"><i class="fa fa-file-excel-o"></i><span>Exportar</span></button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Filtros de la consulta</h5>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select">
                            <div class="select-field">
                                <select name="tipo_abono" id="tipo_abono" v-model="form.tipo_abono">
                                    <option v-for="tipoAbono in tiposAbono" :value="tipoAbono.id" :key="tipoAbono.id">
                                        {{ tipoAbono.nombre }}
                                    </option>
                                </select>
                                <label for="tipo_abono">Tipo de abono</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="form-group">
                                <input-field readonly id="proveedor" v-model="nombreProveedor" name="proveedor">
                                    Proveedor
                                </input-field>
                                <button type="button" @click="seleccionarProveedor" class="btn-info">
                                    <i class="fa fa-search"></i>
                                </button>
                                <button v-show="form.persona_id !== ''" @click="quitarProveedor" type="button" class="btn-danger">
                                    <i class="fa fa-ban"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select">
                            <div class="select-field">
                                <select @change="changePersonalizado" name="tipo_abono" id="tipo_fecha" v-model="form.tipo_fecha">
                                    <option value="H">Hoy</option>
                                    <option value="A">Ayer</option>
                                    <option value="P">Personalizado</option>
                                </select>
                                <label for="tipo_fecha">Tipo de fecha</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4" v-show="form.tipo_fecha === 'P'">
                        <div class="form-field">
                            <div class="datepicker-field datepicker-field--stretch">
                                <date-picker
                                name="desde"
                                v-model="form.desde"
                                type="date"
                                format="dd-MM-yyyy"
                                id="desde"
                                lang="es"
                                ></date-picker>
                                <label>Desde</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4" v-show="form.tipo_fecha === 'P'">
                        <div class="form-field">
                            <div
                                class="datepicker-field datepicker-field--stretch"
                            >
                                <date-picker
                                name="hasta"
                                v-model="form.hasta"
                                type="date"
                                format="dd-MM-yyyy"
                                id="hasta"
                                lang="es"
                                ></date-picker>
                                <label>Hasta</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <p>
                            <label for="por_vencer">
                                <input v-model="form.por_vencer" type="checkbox" name="por_vencer" id="por_vencer"><span>Cheques por vencer</span>
                            </label>
                        </p>
                    </div>
                    <div v-show="form.por_vencer" class="col-xs-12 col-md-4">
                        <div class="form-group">
                            <div class="datepicker-field"
                            >
                                <date-picker
                                    name="a_fecha"
                                    v-model="form.a_fecha"
                                    type="date"
                                    format="dd-MM-yyyy"
                                    id="hasta"
                                    lang="es"
                                ></date-picker>
                                <label>A la fecha</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mt-2">
            <div class="card__title">
                <h5>Resultados de la consulta</h5>
            </div>
            <div class="card__content">
                <k-table
                    @verDocumento="verDocumento"
                    :searchEnabled="false"
                    :filterStatus="false"
                    ref="tablaAbonos"
                    :createButton="false"
                    :editButton="false"
                    :deleteButton="false"
                    :path="path"
                    :params="form"
                    :columns="[
                        {
                            display: 'Comprobante',
                            value: 'comprobante.numero',
                        },
                        {
                            display: 'Proveedor',
                            value: 'comprobante.nombre_comercial',
                        },
                        {
                            display: 'Fecha',
                            value: 'fecha_abono',
                        },
                        {
                            display: 'Tipo de abono',
                            value: 'descripcion_tipo_abono',
                        },
                        {
                            display: 'Referencia',
                            value: 'referencia',
                        },
                        {
                            display: 'Fecha de emisión',
                            value: 'fecha_emision',
                        },
                        {
                            display: 'Fecha de vencimiento',
                            value: 'fecha_vencimiento',
                        }
                    ]"
                    :buttons="[
                        {
                            event: 'verDocumento',
                            class: 'btn-info btn---text',
                            icon: 'fa fa-eye'
                        }
                    ]"
                    ></k-table>
            </div>
        </div>
        <modal height="auto" width="70%" name="proveedor" scrollable>
            <lista-personas :filterStatus="false" @selected="selectedProveedor"></lista-personas>
        </modal>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            nombreProveedor: '',
            path: url + '/compras/abonos',
            form: {
                tipo_abono: 'T',
                tipo_fecha: 'H',
                desde: '',
                hasta: '',
                exportar: 'N',
                persona_id: '',
                por_vencer: false,
                a_fecha: moment(new Date()).format('YYYY-MM-DD')
            },
            tiposAbono : [
                {
                    id : 'T',
                    nombre : 'Todos'
                },
                {
                    id : 'EF',
                    nombre : 'Efectivo'
                },
                {
                    id : 'CH',
                    nombre : 'Cheque'
                },
                {
                    id : 'DEP',
                    nombre : 'Depósito bancario'
                },
                {
                    id : 'CRE',
                    nombre : 'Tarjeta de crédito'
                },
                {
                    id : 'DEB',
                    nombre : 'Tarjeta de débito'
                },
                {
                    id : 'TRANS',
                    nombre : 'Transferencia'
                },
                {
                    id : 'RET',
                    nombre : 'Retención'
                },
                {
                    id : 'NC',
                    nombre : 'Nota de crédito'
                }
            ]
        };
    },
    methods: {
        verDocumento: function (documento) {
            window.open(url + '/compras/' + documento.compra_id + '/edit', '_blank');
        },
        selectedProveedor: function (proveedor) {
            this.form.persona_id = proveedor.id;
            this.nombreProveedor = proveedor.nombre;
            this.$modal.hide('proveedor');
        },
        quitarProveedor: function () {
            this.nombreProveedor = '';
            this.form.persona_id = '';
        },
        seleccionarProveedor: function () {
            this.$modal.show('proveedor');
        },
        serialize: function(obj) {
            return (
                "?" +
                Object.keys(obj)
                .reduce(function(a, k) {
                    let val = obj[k];
                    let esArray = false;
                    if (val instanceof Date) {
                    val = val.toLocaleDateString("en");
                    } else if (val instanceof Array) {
                    esArray = true;
                    let acumulador = "";
                    for (let i = 0; i < val.length; i++) {
                        acumulador += k + "%5B%5D=" + val[i];
                        if (i != val.length - 1) {
                        acumulador += "&";
                        }
                    }
                    val = acumulador;
                    a.push(val);
                    }
                    if (!esArray) a.push(k + "=" + encodeURIComponent(val));
                    return a;
                }, [])
                .join("&")
            );
        },
        changePersonalizado: function () {
            let desde = new Date();
            desde.setDate(desde.getDate() - 30);
            let hasta = new Date();
            this.form.desde = moment(desde).format('YYYY-MM-DD');
            this.form.hasta = moment(hasta).format('YYYY-MM-DD');
        },
        consultar: function () {
            this.form.exportar = "N";
            this.$refs.tablaAbonos.loadRows();
        },
        exportar: function () {
            this.form.exportar = "S";
            let urlApi = url + "/compras/abonos" + this.serialize(this.form);
            window.open(urlApi, "_blank");
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/compras/ReporteAbonosCompra.vue